import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Help from './Help';
import styles from './styles/index.module.scss';

const Reinsurance = ({ className }) => (
  <div className={cn(styles.reinsurance, className)}>
    <Help />
  </div>
);

Reinsurance.propTypes = {
  className: PropTypes.string,
};

Reinsurance.defaultProps = {
  className: null,
};

Reinsurance.displayName = 'Reinsurance';

export default Reinsurance;
